<script>
    import { onMount } from 'svelte'
    export let person
</script>

<div class="person">
    <div class="meta">
        <p>
            <span class="bold">
                {person.first_name} {person.last_name}
            </span>
            {person.current}
        </p>
    </div>
</div>

<style lang="scss">
    .person {
        grid-column: span 3;
        margin-top: 0.4rem;

        .imgContainer {
            position: relative;
            width: 100%;
            height: 0;
            padding-top: 100%;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top:0;
        }
    }

    .name {
        font-family: "Ysabeau";
        font-weight: bold;
        font-size: 1.3rem;
        margin: 0.4rem 0 0.2rem;
    }

    .meta p {
        margin: 0;
        font-size: 1rem;
        font-family: "Ysabeau";

        .bold {
            font-weight: bold;
        }

        a {
            border-bottom: 2px solid black;
            color:black;
            text-decoration: none;

            &:hover {
                text-decoration: none;
            }
        }
    }
</style>
